import { RentalAgencyApiItem } from 'features/RentalAgency/types';
import { createResourceApi } from 'resources/ResourceApi';

export const apiKey = 'rental_agencies';

export default createResourceApi<RentalAgencyApiItem>(apiKey);
